/**
 * Hand als Piktogramm in der Seitenansicht: flache Hand mit geschlossenen
 * Fingern nach rechts, Daumen oben am Handrücken, Unterarm schräg nach links
 * oben. Der Handballen liegt im Ursprung, die Handfläche zeigt nach unten.
 */
import { STROKE } from '../palette.ts';
import { path, roundedRectPath } from '../paths.ts';
import { group, shape, styles } from '../scene.ts';
import type { SceneNode } from '../scene.ts';

/** Hand mit Unterarm; place() aus utensils.ts platziert und dreht sie. */
export function hand(): SceneNode[] {
  // Handfläche und Finger als ein Umriss: unten flach, vorn abgerundete Fingerspitzen.
  const palm = path()
    .move(-4, 0)
    .line(34, 0)
    .quad(44, 0, 44, -6)
    .quad(44, -12, 34, -13)
    .line(14, -18)
    .quad(2, -22, -6, -18)
    .quad(-12, -8, -4, 0)
    .close()
    .toString();
  // Daumen liegt oben am Handrücken an.
  const thumb = path()
    .move(6, -18)
    .quad(14, -26, 26, -20)
    .quad(30, -17, 26, -15)
    .line(12, -14)
    .close()
    .toString();
  const fingers = [-4, -8].map((y, index) =>
    shape(
      path()
        .move(22 + index * 2, y)
        .line(42 - index * 2, y - 0.5)
        .toString(),
      {
        stroke: 'shade',
        strokeWidth: STROKE.detail,
      },
    ),
  );
  return [
    // Unterarm mit Ärmel
    group([shape(roundedRectPath(-10, -52, 20, 40, 9), styles.solid('tint'))], {
      transform: { rotate: -28, ox: 0, oy: -14 },
    }),
    shape(palm, styles.solid('paper')),
    ...fingers,
    shape(thumb, styles.solid('paper')),
  ];
}
